import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_production/69e77ef063911b00142217d8_1780927938162_b98b800e/netwatch/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69e77ef063911b00142217d8_1780927938162_b98b800e/netwatch/src/styles/tailwind.css");
